<template>
  <div :class="data.backgroundColor === 'Light Gray' ? 'bg-gray-100' : 'bg-gray-300'">
    <div class="grid-default container py-14 lg:py-20">
      <div class="col-span-6 mb-8 lg:col-span-5 lg:col-start-1">
        <Heading
          v-if="data.title"
          :level="5"
          class="pb-6 text-3xl font-normal lg:pb-8 lg:text-6xl"
          >{{ data.title }}</Heading
        >
        <div
          class="text-base font-normal text-neutral-500 lg:text-4xl"
          v-html="data.subHeadline"
        ></div>
        <div v-for="(button, idx) in data.button" :key="idx">
          <Button
            :label="button.label"
            :to="button.reference ?? button.externalLink"
            :target="button.externalLink ? '_blank' : undefined"
            :variant="'solid'"
            :color="button.variant === 'solid' ? 'default' : 'gray'"
            :class="'mt-6 lg:mt-8'"
            :icon="button.icon"
          />
        </div>
      </div>
      <div role="presentation" class="col-span-6 lg:col-span-7 lg:col-start-6">
        <AccordionPanel
          v-for="(item, idx) in data.faq"
          :key="idx"
          :idx="idx"
          :active="activeIdx === idx"
          class="mb-6 lg:mb-9"
          @expand="activeIdx = activeIdx !== idx ? idx : null"
        >
          <template #title
            >{{ item.question }}</template
          >
          <template #content> <div v-html="item.answer"></div> </template>
        </AccordionPanel>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { SectionFaqRecord } from '~/types/generated'

defineProps({
  data: {
    type: Object as PropType<SectionFaqRecord>,
    default: () => {}
  }
})

const activeIdx = ref<number | null>(null)
</script>
